import dayjs from "dayjs";
import { Tooltip, Stack } from "@altimateai/lego";
import { ClockBlackIcon } from "@assets/icons";
import { CollapsibleField } from "@/components/text";
import { getNamedResourceImageByType } from "../../resourceTag/utils";
import { getResourceImageType } from "../../../utils";

interface DetailsCellProps {
  resource_name: string;
  resource_type: number;
  resource_uri: string;
  opportunity_name: string;
  description: string;
  last_seen: string;
  first_seen: string;
  count: number;
  total_count: number;
}

export const DetailsCell = ({
  resource_name,
  resource_type,
  resource_uri,
  opportunity_name,
  description,
  last_seen,
  first_seen,
  count,
  total_count,
}: DetailsCellProps) => {
  return (
    <Stack direction={"column"} align={"start"} gap={"sm"} className={"al-px-2 overflow-hidden"}>
      <Stack align={"center"} gap={"sm"} className={"al-w-full"}>
        <Stack align={"center"} gap={"xs"} className={"al-p-1 al-rounded al-bg-[#d5e7ff]"}>
          {getNamedResourceImageByType(getResourceImageType(resource_type))}
        </Stack>
        {resource_name && (
          <div
            className={
              "al-min-w-[130px] al-overflow-hidden al-p-1 al-gap-1 al-rounded al-bg-[#d5e7ff] al-text-brand al-text-center al-overflow-ellipsis al-text-nowrap al-text-xs al-font-medium al-leading-4"
            }
          >
            {resource_name}
          </div>
        )}
        <Stack
          justify={"center"}
          align={"center"}
          gap={"md"}
          className={
            "al-px-1 al-py-1.5 al-gap-2.5 al-rounded al-bg-brand al-text-white al-text-sm al-font-medium"
          }
        >
          {opportunity_name}
        </Stack>
      </Stack>
      {(resource_type === 1 || resource_type === 2) && (
        <Stack
          align={"center"}
          gap={"xxs"}
          className={"al-w-full al-font-normal al-text-xs al-leading-4 al-text-dark-gray"}
        >
          <span>{`${resource_type === 1 ? "ID" : "Path"}:`}</span>
          <span className={"al-text-brand"}>{resource_uri}</span>
        </Stack>
      )}
      <Stack align={"center"} gap={"sm"} className={"al-w-full al-text-dark-gray"}>
        <div className={"al-w-full al-text-wrap"}>
          <CollapsibleField
            label=""
            text={description}
            defaultLines={2}
            alignCenter={true}
            textStyle=""
          />
        </div>
      </Stack>
      <Stack align={"center"} gap={"lg"} className={"al-text-dark-gray"}>
        <Stack align={"center"} gap={"xxs"}>
          <ClockBlackIcon />
          <Stack align={"center"} gap={"xxs"} className={"al-text-xs al-font-normal al-leading-4"}>
            <Tooltip
              title={
                <>
                  <div>First seen</div>
                  <div>{dayjs(first_seen).format("DD MMM YYYY hh:mm:ss A")}</div>
                </>
              }
            >
              <span>{dayjs(first_seen).fromNow()}</span>
            </Tooltip>{" "}
            |{" "}
            <Tooltip
              title={
                <>
                  <div>Last seen</div>
                  <div>{dayjs(last_seen).format("DD MMM YYYY hh:mm:ss A")}</div>
                </>
              }
            >
              <span>{dayjs(last_seen).fromNow()}</span>
            </Tooltip>
          </Stack>
        </Stack>
        {resource_type === 1 && (
          <Stack
            align={"center"}
            className={
              "al-rounded-full al-bg-[#ffeae4] al-text-[#ff7064] al-text-xs al-font-medium al-leading-5 al-px-1.5 al-py-0.5"
            }
          >
            <Tooltip
              title={`This opportunity was detected ${count} times in ${total_count} query runs that happened. `}
            >
              <span>Count: {count}</span>
            </Tooltip>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
